/** 能源 — 空调用电报表 /energy/charging-sankey（chargingReport.vue） */
export default {
  chargingReport: {
    filterStatPeriod: '统计时间',
    phDateStart: '开始时间',
    phDateEnd: '结束时间',
    filterTenant: '选择租户',
    phTenant: '请选择租户',
    filterAir: '选择空调',
    phAir: '请选择空调',
    exportLoading: '导出中...',
    exportReport: '导出报表',
    exportCurrentPage: '导出本页',
    exportAll: '导出全部',
    loadingText: '数据加载中...',
    sectionTitle: '空调用电',
    sectionTip: '请选择日期后查看数据',
    colOutdoor: '外机系统名称',
    colMeter: '计量电表',
    colMeterTotalKwh: '计量总电量(kwh)',
    colAirName: '空调名称',
    colBindInfo: '绑定信息',
    summaryGroup: '汇总',
    colTotalTime: '总计(时长)',
    colTotalKwh: '总电量(kwh)',
    colTotalSysKwh: '系统总电量(kWh)',
    colTotalFee: '总电费(元)',
    suffixDuration: '时长',
    suffixElec: '电量',
    suffixSysElec: '系统电量(kWh)',
    sysElecSubHead: '系统电量(kWh)',
    suffixFee: '电费',
    emptyNoData: '暂无数据',
    tenantAll: '全部',
    airAll: '全部',
    unitHours: 'h',
    pickerLast7: '最近7天',
    pickerLast15: '最近15天',
    pickerLast30: '最近30天',
    pickerThisMonth: '本月',
    pickerLastMonth: '上月',
    msgTenantListFail: '获取租户列表失败',
    msgAirListFail: '获取空调列表失败',
    msgDateMax31: '日期最多只能选择31天',
    msgFetchFail: '获取数据失败',
    msgExportEmpty: '暂无数据可导出',
    msgExportOk: '导出成功！',
    msgExportLimit: '共 {total} 条，已导出前 {count} 条',
    msgExportFail: '导出失败',
    msgExportRetry: '请重试',
    exportFilterLine: '统计时间: {start} 至 {end}  |  租户: {tenant}  |  空调: {air}',
    exportSheetName: '空调用电报表',
    exportFilePrefix: '空调用电报表',
    expColOutdoor: '外机系统名称',
    expColMeter: '计量电表',
    expColMeterTotal: '计量总电量(kwh)',
    expColAirName: '空调名称',
    expColBind: '绑定信息',
    expSummary: '汇总',
    expTotalTime: '总计(时长)',
    expTotalKwh: '总计(电量)',
    expTotalSysKwh: '系统总电量(kWh)',
    expTotalFee: '总计(电费)'
  }
}
